var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRocketCohete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120.135,
    height: 118.573,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Rocket-cohete_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 2577",
    d: "M31.939 27.774c-.237 1.2-9.662 9.157-9.662 9.157a3.6 3.6 0 01-2.235-.14c-2.674-1.1-12.51-11.667-12.51-11.667a36.167 36.167 0 01-6.2-13.478C-.112 4.262-.212.554.235.094s6.838.7 13.326 5.028a49.915 49.915 0 019.406 8.252l8.12 11.878a3.675 3.675 0 01.852 2.522z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 2996"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 2994"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 2571",
    d: "M82.723 50.241c1.7-1.343 9.471.818 12.615 6.608 2.127 3.919-5.108 9.87-8.287 6.943-2.552-2.352-6.756-11.636-4.328-13.551z",
    fill: "#f3d231"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 2572",
    d: "M87.7 56.55c.882-.696 4.915.425 6.545 3.428 1.1 2.034-2.65 5.121-4.3 3.602-1.324-1.22-3.5-6.036-2.245-7.03z",
    fill: "#eeb32a"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 2573",
    d: "M88.167 67.278a9.909 9.909 0 01-3.883 3.743c-2.314.99-4.757 1.538-4.708 2.769s3.646 4.223 8.086 5.948a20.045 20.045 0 0010.35.924c1.445-.281-9.845-13.384-9.845-13.384z",
    fill: "#70578b"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 2574",
    d: "M98.189 57.442a9.911 9.911 0 003.931-3.692c1.1-2.261 1.772-4.675 3-4.563s4.037 3.851 5.539 8.373a20.049 20.049 0 01.406 10.381c-.351 1.429-12.876-10.499-12.876-10.499z",
    fill: "#cb5253"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 2991"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 2575",
    d: "M88.196 66.956c.237-1.2 9.662-9.157 9.662-9.157a3.6 3.6 0 012.235.14c2.674 1.1 12.51 11.667 12.51 11.667a36.167 36.167 0 016.2 13.478c1.444 7.384 1.544 11.092 1.097 11.552s-6.838-.7-13.326-5.028a49.915 49.915 0 01-9.406-8.252l-8.12-11.878a3.675 3.675 0 01-.852-2.522z",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 2990"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 2989",
    clipPath: "url(#Rocket-cohete_svg__a)",
    transform: "rotate(-180 60.067 47.365)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 2576",
    d: "M.671-.59s2.14 16.686 10.426 24.748a98.729 98.729 0 0014.11 11.758l-3.808 2.464S8.857 28.75 5.833 23.823-.438 13.296-.549 7.585.671-.59.671-.59z",
    fill: "#d2d4d6"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 2992"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 2578",
    d: "M99.043 65.763a3.528 3.528 0 11-3.645 3.406 3.532 3.532 0 013.645-3.406zm-.192 5.708a2.184 2.184 0 10-2.11-2.255 2.186 2.186 0 002.11 2.255z",
    fill: "#c5c5c5"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 2993"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 2579",
    d: "M105.872 72.493a3.528 3.528 0 11-3.643 3.406 3.531 3.531 0 013.643-3.406zm-.191 5.708a2.184 2.184 0 10-2.109-2.255 2.186 2.186 0 002.109 2.255z",
    fill: "#c5c5c5"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 2580",
    stroke: "#dbdbdb",
    d: "M77.053 46.017a84.162 84.162 0 00-41.637-7.336c-24.005 1.842-25.271-12.837-25.7-16.466S9.8.257 30.343 1.57s21.111 28 5.075 53.267-10.546 35.7-10.546 35.7",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    strokeDasharray: "0 9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 2581",
    d: "M52.817 94.649a10.8 10.8 0 00-6.128-3.869A7.352 7.352 0 0040.5 79.445a6.962 6.962 0 00-4.775 1.784 14.71 14.71 0 00-5.394-6.617 14.263 14.263 0 00-8.242-2.532 14.191 14.191 0 00-10.41 4.312A14.188 14.188 0 007.364 86.81q0 .432.058 1.237a12.684 12.684 0 00-5.379 4.7 12.843 12.843 0 001.74 16.052 12.411 12.411 0 009.1 3.783h31.3a11.042 11.042 0 008.629-17.937z",
    fill: "#d4d5d9"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "fluffy-cloud-silhouette"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 2581",
    d: "M59.801 100.635a10.8 10.8 0 00-6.128-3.869 7.352 7.352 0 00-6.189-11.335 6.962 6.962 0 00-4.775 1.784 14.71 14.71 0 00-5.394-6.617 14.263 14.263 0 00-8.242-2.532 14.191 14.191 0 00-10.41 4.312 14.188 14.188 0 00-4.315 10.418q0 .432.058 1.237a12.684 12.684 0 00-5.379 4.7 12.843 12.843 0 001.74 16.052 12.411 12.411 0 009.1 3.783h31.3a11.042 11.042 0 008.629-17.937z",
    fill: "#f0f0f0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketCohete);
export default __webpack_public_path__ + "static/media/Rocket-cohete.74f171f8.svg";
export { ForwardRef as ReactComponent };